import { __assign } from "tslib";
import { useTuiState } from '@office-start/teaching-ui-service';
import React, { Suspense } from 'react';
import { useShellElements } from './hooks/useShellElements';
import { TuiExtraActivationDataLoader } from './TuiExtraSettingsLoader';
var LazyTeachingUiComponent = React.lazy(function () { return import('./TeachingUiComponent'); });
export var TeachingUiContainerComponent = function (_a) {
    var _b;
    var userProfileService = _a.userProfileService, scrollContentRef = _a.scrollContentRef, 
    // Default to shell height
    _c = _a.topOffset, 
    // Default to shell height
    topOffset = _c === void 0 ? 42 : _c;
    // Setup shell elements
    var reloadShellElements = useShellElements();
    // Fetch Callouts
    var _d = useTuiState(userProfileService), elementMap = _d.elementMap, activeSequence = _d.activeSequence, customActionProps = _d.customActionProps, disabled = _d.disabled, setupCompleted = _d.setupCompleted;
    return (React.createElement(React.Fragment, null,
        // Only run the hook while we are setting up the TUI
        !setupCompleted ? React.createElement(TuiExtraActivationDataLoader, null) : null,
        // Only render if we have callouts and elements and its not disabled
        !disabled &&
            ((_b = activeSequence === null || activeSequence === void 0 ? void 0 : activeSequence.callouts) === null || _b === void 0 ? void 0 : _b.length) &&
            elementMap.size > 0 ? (React.createElement(Suspense, { fallback: null },
            React.createElement(LazyTeachingUiComponent, __assign({}, {
                elementMap: elementMap,
                activeSequence: activeSequence,
                customActionProps: customActionProps,
                scrollContentRef: scrollContentRef,
                topOffset: topOffset,
                reloadShellElements: reloadShellElements,
            })))) : null));
};
//# sourceMappingURL=TeachingUiContainerComponent.js.map